// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file types/v1/area.proto (package types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file types/v1/area.proto.
 */
export const file_types_v1_area: GenFile = /*@__PURE__*/
  fileDesc("ChN0eXBlcy92MS9hcmVhLnByb3RvEgh0eXBlcy52MSIoCglZZWFyTW9udGgSDAoEeWVhchgBIAEoDRINCgVtb250aBgCIAEoDSrvAQoIQXJlYUNvZGUSGQoVQVJFQV9DT0RFX1VOU1BFQ0lGSUVEEAASFgoSQVJFQV9DT0RFX0hPS0tBSURPEAESFAoQQVJFQV9DT0RFX1RPSE9LVRACEhMKD0FSRUFfQ09ERV9UT0tZTxADEhMKD0FSRUFfQ09ERV9DSFVCVRAEEhYKEkFSRUFfQ09ERV9IT0tVUklLVRAFEhQKEEFSRUFfQ09ERV9LQU5TQUkQBhIVChFBUkVBX0NPREVfQ0hVR09LVRAHEhUKEUFSRUFfQ09ERV9TSElLT0tVEAgSFAoQQVJFQV9DT0RFX0tZVVNIVRAJQp4BCgxjb20udHlwZXMudjFCCUFyZWFQcm90b1ABWkJnaXRodWIuY29tL2VuZWNoYWluL2Vwb3NpdGlvbi1hcHAvYmFja2VuZC9nZW4vcHJvdG8vdHlwZXMvdjE7dHlwZXOiAgNUWFiqAghUeXBlcy5WMcoCCFR5cGVzXFYx4gIUVHlwZXNcVjFcR1BCTWV0YWRhdGHqAglUeXBlczo6VjFiBnByb3RvMw");

/**
 * @generated from message types.v1.YearMonth
 */
export type YearMonth = Message<"types.v1.YearMonth"> & {
  /**
   * @generated from field: uint32 year = 1;
   */
  year: number;

  /**
   * @generated from field: uint32 month = 2;
   */
  month: number;
};

/**
 * Describes the message types.v1.YearMonth.
 * Use `create(YearMonthSchema)` to create a new message.
 */
export const YearMonthSchema: GenMessage<YearMonth> = /*@__PURE__*/
  messageDesc(file_types_v1_area, 0);

/**
 * @generated from enum types.v1.AreaCode
 */
export enum AreaCode {
  /**
   * @generated from enum value: AREA_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 北海道
   *
   * @generated from enum value: AREA_CODE_HOKKAIDO = 1;
   */
  HOKKAIDO = 1,

  /**
   * 東北
   *
   * @generated from enum value: AREA_CODE_TOHOKU = 2;
   */
  TOHOKU = 2,

  /**
   * 東京
   *
   * @generated from enum value: AREA_CODE_TOKYO = 3;
   */
  TOKYO = 3,

  /**
   * 中部
   *
   * @generated from enum value: AREA_CODE_CHUBU = 4;
   */
  CHUBU = 4,

  /**
   * 北陸
   *
   * @generated from enum value: AREA_CODE_HOKURIKU = 5;
   */
  HOKURIKU = 5,

  /**
   * 関西
   *
   * @generated from enum value: AREA_CODE_KANSAI = 6;
   */
  KANSAI = 6,

  /**
   * 中国
   *
   * @generated from enum value: AREA_CODE_CHUGOKU = 7;
   */
  CHUGOKU = 7,

  /**
   * 四国
   *
   * @generated from enum value: AREA_CODE_SHIKOKU = 8;
   */
  SHIKOKU = 8,

  /**
   * 九州
   *
   * @generated from enum value: AREA_CODE_KYUSHU = 9;
   */
  KYUSHU = 9,
}

/**
 * Describes the enum types.v1.AreaCode.
 */
export const AreaCodeSchema: GenEnum<AreaCode> = /*@__PURE__*/
  enumDesc(file_types_v1_area, 0);

